
import { Vue, Options } from 'vue-class-component'
import { Getter, Action } from 'vuex-class'
import audioPlayer from '@/utils/sounds'
import { Device } from '@/store/types'
import { Watch } from 'vue-property-decorator'
import screenfull from 'screenfull'
import { EventBuss, SOCKET_MESSAGE } from './utils/constants'
import NumnericKeyboard from '@/components/numeric-virtual-keyborad.vue'
import { AppMutation } from './store/module/app'
import { MJWebsocket } from './utils/websocket'
import router, { ROUTES } from './router'
import { useI18n } from 'vue-i18n'
import { UserMutation } from './store/module/user'
import { store } from './store'
import { AxiosSource, logOut, showRedPacketAds } from './api'
import axios from 'axios'
import { useAssetPreload } from './composables/useAssetPreload'
import PopModalVue from './components/dialogs/pop-modal.vue'

//防抖
const debounce = <T extends (...args: any[]) => void>(
    func: T,
    delay: number
) => {
    let inDebounce: ReturnType<typeof setTimeout>

    return function (this: ThisParameterType<T>, ...args: Parameters<T>) {
        clearTimeout(inDebounce)
        inDebounce = setTimeout(() => func.apply(this, args), delay)
    }
}

// 节流函数
const throttle = <T extends (...args: any[]) => void>(
    func: T,
    limit: number
) => {
    let inThrottle = false

    return function (this: ThisParameterType<T>, ...args: Parameters<T>) {
        if (!inThrottle) {
            func.apply(this, args)
            inThrottle = true
            setTimeout(() => (inThrottle = false), limit)
        }
    }
}

@Options({
    components: {
        NumnericKeyboard,
        'pop-modal': PopModalVue
    }
})
class App extends Vue {
    message!: string
    isMobile = false

    initialWidth = 0
    initialHeight = 0
    isPopupOpen = false
    // isPopupOpen = true

    resizeTimerFlag: number | boolean = false

    isFirstLoad = true

    toastMessage = ''
    toastInterval: boolean | number = false
    toastCounter = 0

    showNumericKeyboard = false

    showRedPacketAdsApiCalled = false

    loadAssetsCall = useAssetPreload().PreloadAssets

    t = useI18n().t

    emitter!: Vue['emitter']
    $router!: Vue['$router']

    _ws!: MJWebsocket

    isPageBlured = false

    networkBanner: '' | 'offline' | 'reconnecting' | 'recovered' = ''
    recoveredBannerTimer: number | boolean = false

    //#region Vuex
    @Getter('device') device!: Device
    @Getter('userHasInteractToPage') interactedToPage!: boolean
    @Getter('isSoundOn') isSoundOn!: boolean
    @Getter('isLoading') isLoading!: boolean
    @Getter('isFullScreen') isFullScreen!: boolean
    @Getter('token') token!: string
    @Getter('serverLine') serverLine!: number
    @Getter('serverLineStr') serverLineStr!: string
    @Getter('memberId') memberId!: number

    @Action('interActPage') interActToPage!: () => void
    @Action('setFullScreen') setFullScreen!: (isFull: boolean) => void

    @Action('checkOrientation') checkOrientation!: () => void
    //#endregion

    //#region Vue Methods
    beforeMount(): void {
        // load assets
        this.loadAssetsCall()

        window.addEventListener('resize', this.handleResizeWindow)
        this.isMobile = this.device.display === 1

        // this will remove the distored size on focus input in mobile
        if (this.isMobile) {
            this.initialWidth = window.innerWidth
            this.initialHeight = window.innerHeight

            const viewport = document.querySelector('meta[name=viewport]')
            viewport?.setAttribute(
                'content',
                'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0'
            )

            window.addEventListener(
                'orientationchange',
                this.onOrientationChange
            )
        }

        document.addEventListener('fullscreenchange', this.fullScreenChange)
        document.addEventListener(
            'webkitfullscreenchange',
            this.fullScreenChange
        )
        document.addEventListener('mozfullscreenchange', this.fullScreenChange)
        document.addEventListener('MSFullscreenChange', this.fullScreenChange)

        this.emitter.on(EventBuss.SOCKET_CONNECT, this.connectToWebsocket)
        this.emitter.on(EventBuss.SOCKET_RECONNECTED, this.handleSocketReconnected)
        this.emitter.on(
            EventBuss.SOCKET_RECONNECT_FAILED,
            this.handleReconnectFailed
        )
        this.emitter.on(EventBuss.SOCKET_DISCONNECTED, this.handleSocketDisconnected)
        this.emitter.on(EventBuss.NETWORK_OFFLINE, this.handleNetworkOffline)
        this.emitter.on(EventBuss.NETWORK_ONLINE, this.handleNetworkOnline)
        this.emitter.on(EventBuss.SESSION_EXPIRED, this.handleEndSession)
        this.emitter.on(EventBuss.LOG_OUT, this.doLogOut)

        document.addEventListener(
            'visibilitychange',
            debounce(this.handlePageVisibilityChange, 200)
        )

        window.addEventListener('blur', this.handlePageBlur)
        window.addEventListener('focus', this.handlePageFocus)

        this._ws = new MJWebsocket(this.emitter)
        this.initWebSocket()
    }

    mounted(): void {
        if (!audioPlayer.isLoaded) {
            audioPlayer.isOn = this.isSoundOn ? 1 : 0
            audioPlayer.LoadSounds()
        }

        // 744 x 360
        // 324 x 744
        // alert(document.body.getBoundingClientRect().width)
        // console.log(window.innerWidth, 'inw')
        // console.log(window.innerHeight, 'inh')

        // alert(window.innerHeight)
        // alert(window.innerWidth)

        // if (!this.isMobile) {
        this.handleResizeWindow()
        // }

        this.$router.isReady().then(() => {
            // console.log(this.$router.currentRoute.value.name)
            // console.log(this.$router.currentRoute.value.name, 'current route')

            // popup open code here need to be removed after testing
            // if (
            //     this.$router.currentRoute.value.name === ROUTES.LOGIN ||
            //     this.$router.currentRoute.value.name === ROUTES.SERVER_SELECTION
            // ) {
            //     {
            //         this.isPopupOpen = true
            //     }
            // }
        })

        if (this.device.display === 1) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            this.emitter.on(EventBuss.ON_ADD_TO_HOME_PAGE, () => {
                // add to home screen code here
            })

            this.emitter.on(
                EventBuss.SHOW_NUMERIC_KEYBOARD,
                this.handlesShowOrHideNumericKeyboard
            )
        }

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        this.emitter.on(EventBuss.TOAST_MESSAGE, this.toastAMaessage)

        if (this.token && !this._ws.isConnected) {
            console.log('connect on mounted')
            this.connectToWebsocket()
        }
    }

    unmounted(): void {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        this.emitter.off(EventBuss.TOAST_MESSAGE, this.toastAMaessage)
        this.emitter.off(EventBuss.SOCKET_CONNECT, this.connectToWebsocket)
        this.emitter.off(EventBuss.SOCKET_RECONNECTED, this.handleSocketReconnected)
        this.emitter.off(EventBuss.SESSION_EXPIRED, this.handleEndSession)
        this.emitter.off(
            EventBuss.SOCKET_RECONNECT_FAILED,
            this.handleReconnectFailed
        )
        this.emitter.off(EventBuss.SOCKET_DISCONNECTED, this.handleSocketDisconnected)
        this.emitter.off(EventBuss.NETWORK_OFFLINE, this.handleNetworkOffline)
        this.emitter.off(EventBuss.NETWORK_ONLINE, this.handleNetworkOnline)
        this.emitter.off(EventBuss.LOG_OUT, this.doLogOut)
        this.clearRecoveredBanner()
        if (this._ws) this._ws.destroy()

        document.removeEventListener(
            'visibilitychange',
            this.handlePageVisibilityChange
        )

        window.removeEventListener('blur', this.handlePageBlur)
        window.removeEventListener('focus', this.handlePageFocus)

        if (this.device.display === 1) {
            this.emitter.off(
                EventBuss.SHOW_NUMERIC_KEYBOARD,
                this.handlesShowOrHideNumericKeyboard
            )
        }
    }

    //#endregion

    //#region Helpers

    handleReconnectFailed(): void {
        this.networkBanner = ''
        this.clearRecoveredBanner()
        if (this._ws) this._ws.close()
        this.toastAMaessage(this.t('prompt.wsrelogin'))
        store.commit(UserMutation.DELETE_SESSION)
        this.$router.push({ name: ROUTES.SERVER_SELECTION })
    }

    handleNetworkOffline(): void {
        if (!this.token) return
        this.clearRecoveredBanner()
        this.networkBanner = 'offline'
    }

    handleNetworkOnline(): void {
        if (!this.token) {
            this.networkBanner = ''
            return
        }
        if (this._ws?.isConnected) {
            if (this.networkBanner) this.showRecoveredBanner()
            return
        }
        if (this.networkBanner) this.networkBanner = 'reconnecting'
        this.connectToWebsocket()
    }

    handleSocketDisconnected(): void {
        if (!this.token) return
        this.clearRecoveredBanner()
        this.networkBanner =
            typeof navigator !== 'undefined' && !navigator.onLine
                ? 'offline'
                : 'reconnecting'
    }

    handleSocketReconnected(): void {
        this.initWebSocket()
        this.showRecoveredBanner()
    }

    showRecoveredBanner(): void {
        if (
            this.networkBanner !== 'offline' &&
            this.networkBanner !== 'reconnecting'
        ) {
            this.networkBanner = ''
            return
        }
        this.networkBanner = 'recovered'
        this.clearRecoveredBanner()
        this.recoveredBannerTimer = window.setTimeout(() => {
            this.recoveredBannerTimer = false
            if (this.networkBanner === 'recovered') this.networkBanner = ''
        }, 2000)
    }

    clearRecoveredBanner(): void {
        if (typeof this.recoveredBannerTimer === 'number') {
            clearTimeout(this.recoveredBannerTimer)
            this.recoveredBannerTimer = false
        }
    }

    get networkBannerText(): string {
        if (this.networkBanner === 'offline') {
            return this.t('prompt.networkoffline')
        }
        if (this.networkBanner === 'reconnecting') {
            return this.t('prompt.networkreconnecting')
        }
        if (this.networkBanner === 'recovered') {
            return this.t('prompt.networkrecovered')
        }
        return ''
    }

    handlePageVisibilityChange() {
        if (document.visibilityState === 'visible') {
            this.isPageBlured = false
            if (this.token && this._ws && !this._ws.isConnected) {
                this.networkBanner = 'reconnecting'
                this.connectToWebsocket()
            }
            this.emitter.emit(EventBuss.PAGE_ON_VISIBLE)
        }
    }

    handlePageBlur() {
        this.isPageBlured = true
    }

    handlePageFocus() {
        if (this.isPageBlured === true) {
            this.handlePageVisibilityChange()
        }
    }

    doLogOut(): void {
        const _params = {
            memberId: this.memberId,
            token: this.token
        }

        // clocse socket

        if (AxiosSource) {
            // cancell all axios pending request
            AxiosSource.Source.cancel()
            AxiosSource.Source = axios.CancelToken.source()
        }

        // this.emitter.emit(EventBuss.SOCKET_CLOSE)
        this.networkBanner = ''
        this.clearRecoveredBanner()
        this._ws.close()
        store.commit(UserMutation.DELETE_SESSION)
        router.push({ name: ROUTES.LOGIN })

        // redirect to
        // store.commit(AppMutation.SHOW_LOADING)

        logOut(_params)
    }

    onConfirmNumericKeyboard(_inputValue: number): void {
        this.showNumericKeyboard = false
        store.commit(AppMutation.SET_CHIP_VALAUE, _inputValue)
    }

    handlesShowOrHideNumericKeyboard(_showOrHide: boolean): void {
        this.showNumericKeyboard = _showOrHide
    }

    initSound(): void {
        // check if a user interaction is done
        //  if not then need to initialize sound
        if (!this.interactedToPage) {
            this.interActToPage()
            audioPlayer.Start()
        }
    }

    fullScreenChange(): void {
        if (
            !document.fullscreenElement &&
            !document.webkitIsFullScreen &&
            !document.mozFullScreen &&
            !document.msFullscreenElement
        ) {
            ///fire your event
            this.setFullScreen(false)
        }
    }

    toastAMaessage(message: string): void {
        // console.log('toast message ' + message)
        this.toastCounter = 9
        this.toastMessage = message
        if (typeof this.toastInterval !== 'number') {
            this.toastInterval = setInterval(() => {
                this.toastCounter -= 1
                if (
                    this.toastCounter <= 0 &&
                    typeof this.toastInterval === 'number'
                ) {
                    clearInterval(this.toastInterval)
                    this.toastInterval = false
                    this.toastMessage = ''
                }
            }, 500)
        }
        //
    }

    //#endregion

    //#region Events

    onOrientationChange(): void {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        this.emitter.emit(EventBuss.ORIENTATION_CHANGE)
        this.checkOrientation()
    }

    handleResizeWindow(): void {
        if (!this.isMobile) {
            const pcMain = document.getElementById('pc-main')
            const body = document.getElementsByTagName('html')[0] as HTMLElement
            if (pcMain && body)
                body.style.fontSize =
                    (pcMain?.getBoundingClientRect().width / 20 / 16 / 8) * 19 +
                    'px'
            // console.log('override font')
        }

        if (typeof this.resizeTimerFlag === 'number') {
            clearTimeout(this.resizeTimerFlag)
            this.resizeTimerFlag = false
        }

        this.resizeTimerFlag = setTimeout(() => {
            if (this.isFirstLoad) {
                this.isFirstLoad = false
            } else {
                if (this.device.display === 1) {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    //@ts-ignore
                    this.emitter.emit(EventBuss.ORIENTATION_CHANGE)
                }

                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                //@ts-ignore
                this.emitter.emit(EventBuss.RELOAD_MAP)

                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                //@ts-ignore
                this.emitter.emit(EventBuss.UPDATE_NOTICE_KEY)
            }
        }, 250)
    }

    connectToWebsocket(): void {
        if (this.token) {
            console.log('connect')
            let servicePath = ''
            if (this.serverLine > 0) {
                if (this.serverLine === 1) {
                    servicePath = `${process.env.API_LINE1}`
                } else if (this.serverLine === 2) {
                    servicePath = `${process.env.API_LINE2}`
                } else if (this.serverLine === 3) {
                    servicePath = `${process.env.API_LINE3}`
                }
            } else if (this.serverLine === -1) {
                servicePath = this.serverLineStr
            }

            const protocol = servicePath.startsWith('https://')
                ? 'wss://'
                : 'ws://'

            const wsPath = servicePath.replace(/^https?:\/\//, protocol)
            this._ws.connect(`${wsPath}/websocketUserServer/${this.token}`)
        }
    }

    initWebSocket() {
        if (this._ws) {
            this._ws.OnMessage = (message: MessageEvent) => {
                if (typeof message.data === 'string') {
                    let objMessage: any
                    try {
                        objMessage = JSON.parse(message.data)
                    } catch {
                        return
                    }

                    if (process.env.LOGSOCKETEVENTS === 'true') {
                        console.log('SOCKET MESSAGE RECEIVED', objMessage)
                    }

                    const _type = objMessage.type.toUpperCase()
                    // console.log(_type)k

                    this.emitter.emit(EventBuss.SOCKET_MESSAGE, objMessage)

                    if (
                        _type === SOCKET_MESSAGE.USER_OUT ||
                        _type === SOCKET_MESSAGE.USER_OUT_BY
                    ) {
                        console.log('check2')
                        this.toastAMaessage(objMessage.content)

                        this.networkBanner = ''
                        this.clearRecoveredBanner()
                        this._ws.close()
                        store.commit(UserMutation.DELETE_SESSION)
                        this.$router.push({ name: ROUTES.LOGIN })
                    } else if (_type === SOCKET_MESSAGE.MEMBER_AMOUNT) {
                        store.commit(
                            UserMutation.SET_BET_COIN,
                            objMessage.data.amount
                        )
                        // console.log(objMessage.data.amount, 'OK')
                    } else if (_type === SOCKET_MESSAGE.WS_EXPIRED) {
                        // console.log('check')
                        this.handleEndSession()
                    }
                }
            }
        }
    }

    handleEndSession = () => {
        console.log('expired here')
        // toast session expired
        this.toastAMaessage(this.t('prompt.sessionexpired'))
        // clear store
        store.commit(UserMutation.DELETE_SESSION)

        // console.log(this._ws)
        this.networkBanner = ''
        this.clearRecoveredBanner()
        if (this._ws) {
            this._ws.close()
            this.$router.push({ name: ROUTES.LOGIN })
        } else {
            window.location.reload()
        }
    }
    //#endregion

    @Watch('isFullScreen')
    OnFullScreenChange(value: boolean): void {
        if (value && this.device.display !== 1) {
            const docEl = document.getElementById('pc-main') as HTMLElement
            if (docEl && screenfull.isEnabled) {
                // beFull(docEl)
                screenfull.request(docEl)
            } else {
                console.log('cant full screen')
            }
        }
    }

    @Watch('$route.name')
    OnRouteChange(_value: string): void {
        if (_value !== 'game' && this.showNumericKeyboard) {
            this.showNumericKeyboard = false
        }

        if (_value === ROUTES.LOGIN) {
            // this.isPopupOpen = true
            if (!this.showRedPacketAdsApiCalled) {
                showRedPacketAds().then((response) => {
                    if (response.data.status === 200 && response.data.data.redShow === 1) {
                        this.isPopupOpen = true
                    }
                    this.showRedPacketAdsApiCalled = true
                })
            }
        }
    }
}
export default App
